export default function Marquee() {
	const marquees = document.querySelectorAll('.marquee');

	if (!marquees.length) return;

	marquees.forEach((marquee) => {
		const logos = marquee.querySelector('.marquee__logos');
		if (!logos || logos.dataset.cloned) return;

		const items = [...logos.children];
		items.forEach((item) => {
			const clone = item.cloneNode(true);
			clone.setAttribute('aria-hidden', 'true');
			logos.appendChild(clone);
		});

		logos.dataset.cloned = 'true';
	});
}
